import type { OrderResponseDto } from '@gm-commercial/entitlements-client/src/api/entitlementsApi';

type OrderStatus = OrderResponseDto['status'];

/**
 * Order statuses that mean billing accepted the order. The remaining statuses
 * (`FAILED`, `CANCELED`, `UNSUPPORTED`) mean it did not.
 */
const SUCCESSFUL_ORDER_STATUSES: readonly OrderStatus[] = [
  'COMPLETE',
  'EXECUTING',
  'PENDING',
  'SCHEDULED',
];

/**
 * Whether the billing order (create-order / enroll-assets) succeeded.
 *
 * This is the only signal available for re-enrolled items: they are settled on
 * the billing side and never get a vendor activation batch to poll, so the order
 * status alone decides whether they succeeded. A missing status is treated as a
 * failure rather than assumed successful.
 */
export const isOrderStatusSuccessful = (status?: OrderStatus): boolean =>
  status !== undefined && SUCCESSFUL_ORDER_STATUSES.includes(status);
